import Field from './field.view';

export default Field;
